export default {
    add: {
        patient: 'Patient:',
        patient_dob: 'DOB:',
        diagnosis: 'Diagnosis: {diagnosis} | Service required: provider visit',
        heading: 'Please upload your consultation report',
        heading_uploading: 'Uploading files...',
        heading_uploaded: '{n} files successfully uploaded!',
        file_limits: 'PDF, PNG, JPG OR JPEG - 50MB maximum file size',
        add_report: 'Add consultation report',
        notes_uploaded: 'Are consultation notes uploaded?',
        buttons: {
            select_more: 'SELECT MORE',
            send_report: 'SEND REPORT',
            confirm: 'CONFIRM',
            skip: 'SKIP',
            yes: 'YES',
            no: 'NO',
        },

        warnings: {
            size_limit: 'A selected file exceeds the 50MB limit. Please condense/optimize the file and upload again.',
            mime_type: 'Invalid file type. Allowed types are: PDF, PNG, JPG or JPEG.',
            error: '{n} file(s) could not be uploaded',
        },
    },

    view: {
        heading: "{firstName} {lastName}'s consultation report ",
        breadcrumb: 'Patient: {firstName} {lastName} | {date}',
        patient: 'Patient: {name}',
        seen_on: 'Seen on: {date}',
        report_not_available: 'This report is no longer available',
        report_expired: 'The time for consulting this report has expired.',
        report_store_time: 'We store consultation reports for 30 days.',

        buttons: {
            open_in_new_tab: 'OPEN IN A NEW TAB',
            download_report: 'DOWNLOAD REPORT',
        },
    },
}
